<div *ngFor="let source of recordingJob.recordingSources" class="source">
  <div
    inlineSVG="/assets/icons/failed.svg"
    class="failure"
    *ngIf="resourceFailed(source)"
  ></div>
  <span (click)="goToMedia(source.id)">{{ source.name }}</span>
  <span
    *ngIf="getPlatformName(source) as platformName"
    class="platform-name"
    >&nbsp;({{ platformName }})</span
  >
</div>
